export default "__VITE_ASSET__B0CkJ2$m__"